import React from 'react'
import { MenuItems } from '../../enums/MenuItems'
import clsx from 'clsx'
import TopBanner from '../../uiV2/common/layout/topBanner/TopBanner'

type Props = {
    children: React.ReactNode
    rightPane?: React.ReactNode
    activeMenuItem: MenuItems
    className?: string
}

function LayoutSplitView({
    children,
    rightPane,
    activeMenuItem,
    className,
}: Props): React.JSX.Element {
    const classes = clsx('h-screen flex flex-col', className)

    return (
        <div className={classes}>
            <TopBanner activeMenuItem={activeMenuItem} />

            <div className="flex flex-1 overflow-hidden">
                <div className="w-2/3 overflow-auto p-4 border-r">
                    {children}
                </div>
                <div className="w-1/3 overflow-auto p-4 bg-gray-50">
                    {rightPane}
                </div>
            </div>
        </div>
    )
}

export default LayoutSplitView
